import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { FirstTestimonials } from './components/Testimonials';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { TomosGrid } from './components/TomosGrid';
import { IncludesTable } from './components/IncludesTable';
import { Bonos } from './components/Bonos';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const secondTestimonialsData = [{
  initials: 'CR',
  name: 'Cecilia R.',
  role: '📍 Canelones | AULA DE ÉXITOS',
  quote: 'El kit de actividades en 3 niveles me salvó. Ya no armo dos materiales distintos por clase. Mis alumnos con más dificultades por fin participan igual que todos.'
}, {
  initials: 'RM',
  name: 'Rosa M.',
  role: '📍 Salto | Maestra Tramo 2',
  quote: 'Con las fichas de Ciencias del Tomo 5, en 10 minutos el grupo entero estaba trabajando solo. Eso antes no pasaba nunca en mi clase.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  role: '📍 Montevideo | Maestra de Aula',
  quote: 'Mis alumnos terminaron el año con una secuencia de Lengua real y coherente. Las familias notaron la diferencia. Yo también.'
}, {
  initials: 'PA',
  name: 'Patricia A.',
  role: '📍 Rivera | Maestra Tramo 2',
  quote: 'Las rúbricas de evaluación fueron un antes y un después. Por fin evalúo con criterio claro y lo puedo fundamentar ante cualquier inspección.'
}];
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <Stats data-id="element-3" />
        <FirstTestimonials data-id="element-4" />
        <PainSection data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <TomosGrid data-id="element-7" />
        <IncludesTable data-id="element-8" />
        <Bonos data-id="element-9" />
        <PricingSection data-id="element-10" />
        <Testimonials testimonials={secondTestimonialsData} background="cream" data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostOfInaction data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <PurchaseNotifications data-id="element-17" />
    </div>;
}